import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import realTimeData from './modules/realTimeData'
import common from './modules/common'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    permission,
    common,
    app,
    realTimeData
  },
  getters
})

export default store
